import { Divider, Form, InputNumber, Spin } from "antd";
import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import svg86 from "../../../assets/svg/svg86.svg";
import svg87 from "../../../assets/svg/svg87.svg";
import { setActiveObj } from "../../../features/obj/objSlice";

function InvestmentAmount({ handleNext, handleBack }) {
  const dispatch =  useDispatch()
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save);
  const onFinish = async (data) => { 
    await dispatch(setActiveObj({ key: "invAmount", data: data.invAmount }))
    await handleNext();
  };

  return (
    <div>
      <div className="flex flex-col items-center w-full justify-center text-center">
        <div className="text-[#1A1A1A] font-sora text-[1.25rem] font-[400] leading-[1.5rem] lg:w-[40rem] w-full lg:mb-[2.5rem] mb-[1rem]">
          Find out how many acres your investment can support across the NISIP
          pathways
        </div>

        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=""
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <Form.Item
            name="invAmount"
            label={"Enter Your Investment Amount"}
            rules={[
              {
                required: true,
                message: "Please add Your Investment Amount",
              },
            ]}
          >
            <InputNumber
              min={0}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
              className="input flex"
            />
          </Form.Item>
          <div className="flex items-center gap-[1rem] text-[#637381] font-sora text-[1rem] font-[400] ">
            <img src={svg86} alt="svg86" /> Calculator uses official NISIP
            budget and acreage ratios
          </div>
        </Form>

        <div className="sticky lg:mb-[6.25rem] mb-[3rem] left-0 w-full lg:mt-[3.75rem] mt-[1rem] lg:px-[5rem] px-3">
          <Divider />
          <div className="flex justify-end mt-[1rem] gap-x-[1.25rem]">
            

            <div className="w-[100px]">
              <button
                onClick={() => form.submit()}
                disabled={saving}
                type="button"
                className="cstm-btn-2"
              >
                {saving ? (
                  <Spin />
                ) : (
                  <>
                    Continue <img src={svg87} alt="svg87" />
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InvestmentAmount;
